import { Link } from "react-router-dom";
import bg1 from "../../assets/images/bg/06.jpg";
import {
  Navbar,
  FeatureOne,
  AboutImage,
  DrTimeTable,
  CtaOne,
  Patients,
  Footer,
} from "../components";
import ScrollTop from "../../components/scrollTop";
import {
  FiFacebook,
  FiLinkedin,
  FiGithub,
  FiTwitter,
} from "../../assets/icons/vander";

import { medicalServices, doctorData, blogData } from "../data";

export const HomePage = () => {
  return (
    <>
      {/* <MarketingModal /> */}

      <Navbar
        manuClass="navigation-menu nav-left nav-light"
        containerClass="container"
      />

      <section
        className="bg-half-260 d-table w-100"
        style={{ backgroundImage: `url(${bg1})` }}
      >
        <div className="bg-overlay bg-overlay-dark"></div>
        <div className="container">
          <div className="row mt-5 mt-lg-0">
            <div className="col-12">
              <div className="heading-title">
                <h4 className="display-4 fw-bold text-white title-dark mt-3 mb-4">
                  El cuidado preanestésico
                  <br /> del futuro (Versión Beta)
                </h4>
                <p className="para-desc text-white-50 mb-0">
                  Optimiza el proceso para que tus pacientes accedan a un
                  procedimiento anestésico o quirúrgico de forma segura y
                  eficiente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <FeatureOne />
        <div className="container mt-100 mt-60">
          <div className="row align-items-center">
            <AboutImage colClass="col-lg-5 col-md-6" />

            <div className="col-lg-7 col-md-6 mt-4 mt-lg-0 pt- pt-lg-0">
              <div className="ms-lg-4">
                <div className="section-title">
                  <h4 className="title mb-4">
                    Atención para el paciente en forma ágil y amable
                  </h4>
                  <p className="text-muted para-desc">
                    Sólo registra la información del paciente y todo será más
                    rápido y seguro mediante GO SAFE.
                  </p>
                  <p className="text-muted para-desc">
                    Enviarémos un instructivo del paso a paso a seguir para
                    entender los cuidados pre anestésticos de tus pacientes de
                    manera personalizada con ayuda de IA.
                  </p>
                  <p className="text-muted para-desc mb-0">
                    De esta manera, podemos estratificar el riesgo y manejo del
                    paciente según riesgo encontrado. Si no requiere cita
                    presencial con anestesiología, estamos obviando el tiempo de
                    pre anestesia.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title mb-4 pb-2 text-center">
                <h4 className="title mb-0">Funcionalidades</h4>
              </div>
            </div>
          </div>

          <div className="row">
            {medicalServices.slice(0, 8).map((item, index) => {
              const Icon = item.icon;
              return (
                <div className="col-xl-3 col-md-4 col-12 mt-5" key={index}>
                  <div className="card features feature-primary border-0">
                    <div className="icon text-center rounded-md">
                      <Icon className="h3 mb-0" />
                    </div>
                    <div className="card-body p-0 mt-3">
                      <Link to="#" className="title text-dark h5">
                        {item.title}
                      </Link>
                      <p className="text-muted mt-3">{item.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <DrTimeTable />

      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-0">Creen en nosotros</h4>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            {doctorData.slice(0, 4).map((item, index) => {
              return (
                <div
                  className="col-xl-3 col-lg-3 col-md-6 mt-4 pt-2"
                  key={index}
                >
                  <div className="card team border-0 rounded shadow overflow-hidden">
                    <div className="team-img position-relative">
                      <img src={item.image} className="img-fluid" alt="" />
                      <ul className="list-unstyled team-social mb-0">
                        <li>
                          <Link
                            to="#"
                            className="btn btn-icon btn-pills btn-soft-primary"
                          >
                            <FiFacebook className="icons" />
                          </Link>
                        </li>
                        <li className="mt-2 ms-0">
                          <Link
                            to="#"
                            className="btn btn-icon btn-pills btn-soft-primary"
                          >
                            <FiLinkedin className="icons" />
                          </Link>
                        </li>
                        <li className="mt-2 ms-0">
                          <Link
                            to="#"
                            className="btn btn-icon btn-pills btn-soft-primary"
                          >
                            <FiGithub className="icons" />
                          </Link>
                        </li>
                        <li className="mt-2 ms-0">
                          <Link
                            to="#"
                            className="btn btn-icon btn-pills btn-soft-primary"
                          >
                            <FiTwitter className="icons" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="card-body content text-center">
                      <Link
                        to="/doctor-team-one"
                        className="title text-dark h5 d-block mb-0"
                      >
                        {item.name}
                      </Link>
                      <small className="text-muted speciality">
                        {item.speciality}
                      </small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <CtaOne />

      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-0">
                  Nuestros pacientes agradecen nuestro servicio
                </h4>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8 mt-4 pt-2 text-center">
              <Patients />
            </div>
          </div>
        </div>

        <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-4">
                  Facilitamos al paciente el diligenciamiento de información
                </h4>
                <p className="text-muted mx-auto para-desc mb-0">
                  Mediante Go safe hacemos el proceso mucho más fácil, enviamos
                  el paso a paso para que nuestros pacientes accedan en forma
                  ágil y sencilla a su proceso anestésico o quirúrgico de baja o
                  media complejidad en tres pasos.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {blogData.slice(0, 3).map((item, index) => (
              <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                  <img src={item.image} className="img-fluid" alt="" />
                  <div
                    className="card-body p-4"
                    style={{ textAlign: "center" }}
                  >
                    <Link to={`#`} className="text-dark title h5">
                      {item.title}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <ScrollTop />

      {/* <div className="btn-group dropup position-fixed bottom-3 start-3">
        <button
          type="button"
          className="btn btn-primary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Chat
        </button>
        <ul className="dropdown-menu">
          
        </ul>
      </div> */}

      {/* <div
        className="card chat chat-person border-0 shadow rounded position-fixed bottom-3 start-3"
        style={{ zIndex: "10" }}
      >
        <SimpleBar
          style={{
            maxHeight: "295px",
            backgroundImage: `url(${bgChat})`,
            backgroundPosition: "center",
            // position: "fixed",
            // bottom: "10px",
            // left: "10px",
          }}
        >
          <ul className="p-4 list-unstyled mb-0 chat" data-simplebar>
            <li>
              <div className="d-inline-block">
                <div className="d-flex chat-type mb-3">
                  <div className="position-relative">
                    <img
                      src={doctorImg}
                      className="avatar avatar-md-sm rounded-circle border shadow"
                      alt=""
                    />
                    <i className="mdi mdi-checkbox-blank-circle text-success on-off align-text-bottom"></i>
                  </div>

                  <div
                    className="flex-1 chat-msg"
                    style={{ maxWidth: "500px" }}
                  >
                    <p className="text-muted small shadow px-3 py-2 bg-light rounded mb-1">
                      Hey Christopher
                    </p>
                    <small className="text-muted msg-time">
                      <FiClock className="me-1 mb-0" />
                      59 min ago
                    </small>
                  </div>
                </div>
              </div>
            </li>
            <li className="chat-right">
              <div className="d-inline-block">
                <div className="d-flex chat-type mb-3">
                  <div className="position-relative chat-user-image">
                    <img
                      src={clientImg}
                      className="avatar avatar-md-sm rounded-circle border shadow"
                      alt=""
                    />
                    <i className="mdi mdi-checkbox-blank-circle text-success on-off align-text-bottom"></i>
                  </div>

                  <div
                    className="flex-1 chat-msg"
                    style={{ maxWidth: "500px" }}
                  >
                    <p className="text-muted small shadow px-3 py-2 bg-light rounded mb-1">
                      Hello Cristino
                    </p>
                    <small className="text-muted msg-time">
                      <FiClock className="me-1 mb-0" />
                      45 min ago
                    </small>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </SimpleBar>
        <div className="p-2 rounded-bottom shadow">
          <div className="row">
            <div className="col">
              <input
                type="text"
                className="form-control border"
                placeholder="Enter Message..."
              />
            </div>
            <div className="col-auto">
              <Link to="#" className="btn btn-icon btn-primary">
                <BsSend />
              </Link>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};
